import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiError } from "./api";

export interface BusinessSummary {
  id: string;
  name: string;
  slug: string;
  is_active: boolean;
}

export type Me =
  | {
      user_kind: "operator";
      operator: { id: string; email: string; display_name: string | null };
      businesses: BusinessSummary[];
      active_business_id: string | null;
    }
  | {
      user_kind: "business_user";
      user: {
        id: string;
        email: string;
        display_name: string | null;
        role: string;
      };
      businesses: BusinessSummary[];
      active_business_id: string;
    };

/** Loads the current session. Returns `null` (not error) when 401, so callers
 *  can decide between "send to /login" and "render the app." */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: async (): Promise<Me | null> => {
      try {
        return await apiFetch<Me>("/api/me");
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}

export async function setActiveBusiness(business_id: string): Promise<void> {
  await apiFetch("/api/me/active-business", {
    method: "POST",
    body: JSON.stringify({ business_id }),
  });
}

export async function logout(): Promise<void> {
  await apiFetch("/auth/logout", { method: "POST" });
}
